import {
	useAiIssueCreationEnablementState,
	useIssueCreateSidePanelContext,
} from '../providers/IssueCreateSidePanelContextProvider.tsx';

import { useIsAIIssueCreationAllowed } from './useIsAIIssueCreationAllowed.tsx';
import { getIsCreateIssueWithAiEnabledByUser } from './localStorageHelpers.ts';

export const useIsAIIssueCreationEnabled = (): boolean => {
	const [{ contentId }] = useIssueCreateSidePanelContext();
	useIsAIIssueCreationAllowed({ contentId });
	const aiIssueCreationEnablement = useAiIssueCreationEnablementState();
	const isAiEnabled = aiIssueCreationEnablement?.isEnabled ?? false;
	const isCreateIssueWithAiEnabledByUser = getIsCreateIssueWithAiEnabledByUser();

	return isAiEnabled && isCreateIssueWithAiEnabledByUser;
};
